
(function () {
  function init(root) {
    if (!root || root.dataset.ready === '1') return;
    root.dataset.ready = '1';

    const q = (s) => root.querySelector(s);
    const fields = ['gw', 'gd', 'bx', 'by', 'rw', 'rd'];
    const overlay = q('[data-overlay]');
    let previousFocus;

    if (!overlay || !q('[data-open]')) return;

    function openPopup() {
      previousFocus = document.activeElement;
      overlay.hidden = false;
      document.body.style.overflow = 'hidden';
      q('[data-close]').focus();
      calculate();
    }

    function closePopup() {
      overlay.hidden = true;
      document.body.style.overflow = '';
      if (previousFocus) previousFocus.focus();
    }

    q('[data-open]').addEventListener('click', openPopup);

    root.querySelectorAll('[data-close]').forEach((button) => {
      button.addEventListener('click', closePopup);
    });

    overlay.addEventListener('click', (event) => {
      if (event.target === overlay) closePopup();
    });

    document.addEventListener('keydown', (event) => {
      if (overlay.hidden) return;

      if (event.key === 'Escape') {
        closePopup();
      }

      if (event.key === 'Tab') {
        const nodes = [
          ...overlay.querySelectorAll('button,input')
        ].filter((element) => element.offsetParent !== null);

        if (!nodes.length) return;

        const first = nodes[0];
        const last = nodes[nodes.length - 1];

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    });

    fields.forEach((key) => {
      const input = q('[data-field="' + key + '"]');
      if (input) input.addEventListener('input', calculate);
    });

    function positions(total, size, quantity) {
      if (size * quantity > total) return null;

      const free = total - size * quantity;
      const result = [];

      for (let i = 0; i < quantity; i++) {
        result.push(
          Math.round(
            free * (i + 1) / (quantity + 1) + size * i
          )
        );
      }

      for (let i = 1; i < result.length; i++) {
        if (result[i] < result[i - 1] + size) return null;
      }

      return result;
    }

    function clearResults() {
      ['sets', 'pieces', 'meters'].forEach((key) => {
        q('[data-' + key + ']').textContent = '–';
      });

      q('[data-breakdown]').textContent = '';
      q('[data-drawing]').replaceChildren();
    }

    function calculate() {
      const values = fields.map((key) =>
        Number(q('[data-field="' + key + '"]').value)
      );

      const [gw, gd, bx, by, rw, rd] = values;

      const n = gw / 40;
      const m = gd / 40;
      const w = rw / 40;
      const h = rd / 40;

      let error = '';

      if (
        ![gw, gd, rw, rd].every(
          (v) => Number.isInteger(v / 40) && v >= 80
        ) ||
        ![bx, by].every(
          (v) => Number.isInteger(v) && v >= 1 && v <= 10
        )
      ) {
        error =
          'Bitte Maße in 40-cm-Schritten und Stellplatzzahlen zwischen 1 und 10 eingeben.';
      } else if (bx * w > n || by * h > m) {
        error =
          'Die Umrandungen passen nicht in die Garage. Bitte Maße oder Stellplatzzahl anpassen.';
      }

      const xs = error ? null : positions(n, w, bx);
      const ys = error ? null : positions(m, h, by);

      if (!error && (!xs || !ys)) {
        error =
          'Diese Umrandungen lassen sich nicht überschneidungsfrei verteilen.';
      }

      const warning = q('[data-warning]');
      warning.hidden = !error;
      warning.textContent = error;

      if (error) {
        clearResults();
        return;
      }

      const verticalLines = new Set();
      const horizontalLines = new Set();
      const ledVertical = new Set();
      const ledHorizontal = new Set();
      const rectangles = [];

      for (const x of xs) {
        for (const y of ys) {
          rectangles.push({ x, y });

          for (const xx of [x, x + w]) {
            verticalLines.add(xx);

            for (let k = y; k < y + h; k++) {
              ledVertical.add(xx + ',' + k);
            }
          }

          for (const yy of [y, y + h]) {
            horizontalLines.add(yy);

            for (let k = x; k < x + w; k++) {
              ledHorizontal.add(k + ',' + yy);
            }
          }
        }
      }

      const normalVertical = [];
      const normalHorizontal = [];

      for (const x of verticalLines) {
        for (let k = 0; k < m; k++) {
          if (!ledVertical.has(x + ',' + k)) {
            normalVertical.push([x, k]);
          }
        }
      }

      for (const y of horizontalLines) {
        for (let k = 0; k < n; k++) {
          if (!ledHorizontal.has(k + ',' + y)) {
            normalHorizontal.push([k, y]);
          }
        }
      }

      const count =
        normalVertical.length + normalHorizontal.length;

      q('[data-sets]').textContent = rectangles.length;
      q('[data-pieces]').textContent = count;

      q('[data-meters]').textContent =
        (count * 0.4).toLocaleString('de-DE', {
          maximumFractionDigits: 1
        }) + ' m';

      q('[data-breakdown]').textContent =
        normalVertical.length +
        ' längs verlaufende + ' +
        normalHorizontal.length +
        ' quer verlaufende Zwischenleisten à 40 cm.';

      draw(
        n, m, rectangles, w, h,
        normalVertical, normalHorizontal
      );
    }

    function draw(n, m, rectangles, w, h, nv, nh) {
      const unit = Math.min(
        30,
        Math.max(6, 650 / Math.max(n, m))
      );

      const padding = 32;
      const width = n * unit + 2 * padding;
      const height = m * unit + 2 * padding;

      const ns = 'http://www.w3.org/2000/svg';
      const svg = document.createElementNS(ns, 'svg');

      svg.setAttribute('viewBox', `0 0 ${width} ${height}`);
      svg.setAttribute('width', width);
      svg.setAttribute('height', height);
      svg.setAttribute('role', 'img');
      svg.setAttribute(
        'aria-label',
        'Garagenplan mit roten LED-Umrandungen und blauen normalen Zwischenleisten'
      );

      function line(x1, y1, x2, y2, color, strokeWidth) {
        const element = document.createElementNS(ns, 'line');

        const attributes = {
          x1,
          y1,
          x2,
          y2,
          stroke: color,
          'stroke-width': strokeWidth,
          'stroke-linecap': 'square'
        };

        for (const [key, value] of Object.entries(attributes)) {
          element.setAttribute(key, value);
        }

        svg.appendChild(element);
      }

      // Fliesenraster
      for (let x = 0; x <= n; x++) {
        line(
          padding + x * unit,
          padding,
          padding + x * unit,
          padding + m * unit,
          '#cbd5e1',
          0.7
        );
      }

      for (let y = 0; y <= m; y++) {
        line(
          padding,
          padding + y * unit,
          padding + n * unit,
          padding + y * unit,
          '#cbd5e1',
          0.7
        );
      }

      // Normale Zwischenleisten (blau)
      for (const [x, y] of nv) {
        line(
          padding + x * unit,
          padding + y * unit,
          padding + x * unit,
          padding + (y + 1) * unit,
          '#0284c7',
          Math.max(3, unit * 0.16)
        );
      }

      for (const [x, y] of nh) {
        line(
          padding + x * unit,
          padding + y * unit,
          padding + (x + 1) * unit,
          padding + y * unit,
          '#0284c7',
          Math.max(3, unit * 0.16)
        );
      }

      // LED-Fahrzeugumrandungen (rot)
      for (const rectangle of rectangles) {
        for (const x of [rectangle.x, rectangle.x + w]) {
          line(
            padding + x * unit,
            padding + rectangle.y * unit,
            padding + x * unit,
            padding + (rectangle.y + h) * unit,
            '#ef4444',
            Math.max(3, unit * 0.16)
          );
        }

        for (const y of [rectangle.y, rectangle.y + h]) {
          line(
            padding + rectangle.x * unit,
            padding + y * unit,
            padding + (rectangle.x + w) * unit,
            padding + y * unit,
            '#ef4444',
            Math.max(3, unit * 0.16)
          );
        }
      }

      // Außenkante der Garage
      const outline = document.createElementNS(ns, 'rect');

      const attributes = {
        x: padding,
        y: padding,
        width: n * unit,
        height: m * unit,
        fill: 'none',
        stroke: '#334155',
        'stroke-width': 2
      };

      for (const [key, value] of Object.entries(attributes)) {
        outline.setAttribute(key, value);
      }

      svg.appendChild(outline);
      q('[data-drawing]').replaceChildren(svg);
    }

    calculate();
  }

  function initializeAll() {
    document.querySelectorAll('.gp-calc').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll);
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', initializeAll);
})();
